function ServerIcon() {
  return (
    <svg width='47' height='46' viewBox='0 0 47 46' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_20714_23459)'>
        <path
          d='M23.5 11.5C21.1463 11.5 0.5 11.339 0.5 5.75C0.5 0.161 21.1463 0 23.5 0C25.8537 0 46.5 0.161 46.5 5.75C46.5 11.339 25.8537 11.5 23.5 11.5ZM3.54367 5.75C4.94667 6.83867 11.6799 8.625 23.5 8.625C35.3201 8.625 42.0533 6.83867 43.4563 5.75C42.0533 4.66133 35.3201 2.875 23.5 2.875C11.6799 2.875 4.94667 4.66133 3.54367 5.75Z'
          fill='#D1D5DC'
        />
        <path
          d='M23.5 23C21.1463 23 0.5 22.839 0.5 17.25C0.5 16.4565 1.144 15.8125 1.9375 15.8125C2.67542 15.8125 3.283 16.3683 3.36542 17.0852C4.25092 18.1451 11.0551 20.125 23.5 20.125C35.9449 20.125 42.7491 18.1451 43.6346 17.0852C43.717 16.3683 44.3246 15.8125 45.0625 15.8125C45.856 15.8125 46.5 16.4565 46.5 17.25C46.5 22.839 25.8537 23 23.5 23ZM43.625 17.2481C43.625 17.25 43.625 17.25 43.625 17.2481V17.2481ZM3.375 17.2481C3.375 17.25 3.375 17.25 3.375 17.2481V17.2481Z'
          fill='#D1D5DC'
        />
        <path
          d='M23.5 34.5C21.1463 34.5 0.5 34.339 0.5 28.75C0.5 27.9565 1.144 27.3125 1.9375 27.3125C2.67542 27.3125 3.283 27.8683 3.36542 28.5852C4.25092 29.6451 11.0551 31.625 23.5 31.625C35.9449 31.625 42.7491 29.6451 43.6346 28.5852C43.717 27.8683 44.3246 27.3125 45.0625 27.3125C45.856 27.3125 46.5 27.9565 46.5 28.75C46.5 34.339 25.8537 34.5 23.5 34.5ZM43.625 28.7481C43.625 28.75 43.625 28.75 43.625 28.7481V28.7481ZM3.375 28.7481C3.375 28.75 3.375 28.75 3.375 28.7481V28.7481Z'
          fill='#D1D5DC'
        />
        <path
          d='M23.5 46C21.1463 46 0.5 45.839 0.5 40.25V5.75C0.5 4.9565 1.144 4.3125 1.9375 4.3125C2.731 4.3125 3.375 4.9565 3.375 5.75V40.0947C4.29692 41.1604 11.0992 43.125 23.5 43.125C35.9008 43.125 42.7031 41.1604 43.625 40.0947V5.75C43.625 4.9565 44.269 4.3125 45.0625 4.3125C45.856 4.3125 46.5 4.9565 46.5 5.75V40.25C46.5 45.839 25.8537 46 23.5 46Z'
          fill='#D1D5DC'
        />
        <path
          d='M10.0807 28.7493C11.1393 28.7493 11.9974 27.8912 11.9974 26.8327C11.9974 25.7741 11.1393 24.916 10.0807 24.916C9.02218 24.916 8.16406 25.7741 8.16406 26.8327C8.16406 27.8912 9.02218 28.7493 10.0807 28.7493Z'
          fill='#D1D5DC'
        />
        <path
          d='M10.0807 17.2493C11.1393 17.2493 11.9974 16.3912 11.9974 15.3327C11.9974 14.2741 11.1393 13.416 10.0807 13.416C9.02218 13.416 8.16406 14.2741 8.16406 15.3327C8.16406 16.3912 9.02218 17.2493 10.0807 17.2493Z'
          fill='#D1D5DC'
        />
        <path
          d='M10.0807 40.2493C11.1393 40.2493 11.9974 39.3912 11.9974 38.3327C11.9974 37.2741 11.1393 36.416 10.0807 36.416C9.02218 36.416 8.16406 37.2741 8.16406 38.3327C8.16406 39.3912 9.02218 40.2493 10.0807 40.2493Z'
          fill='#D1D5DC'
        />
      </g>
      <defs>
        <clipPath id='clip0_20714_23459'>
          <rect width='46' height='46' fill='white' transform='translate(0.5)' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ServerIcon
